/** Parâmetros padrão da Simulação de Custos de Transporte */
export const SIMULACAO_DEFAULTS = {
  maoDeObra: 0.3,
  pneu: 0.02,
  manutencao: 0.81,
  custoFixo: 0.085,
  margem: 0.2,
  divisorTocoRural: 12000,
  divisorTruckCidade: 20000,
};

/**
 * Média de consumo na planilha: preço S10 / 4.
 * Aqui usamos o preço de custo do produto selecionado.
 */
export function calcMediaConsumo(precoCusto) {
  return (Number(precoCusto) || 0) / 4;
}

export function calcCustoVariavel({
  precoCusto,
  maoDeObra = SIMULACAO_DEFAULTS.maoDeObra,
  pneu = SIMULACAO_DEFAULTS.pneu,
  manutencao = SIMULACAO_DEFAULTS.manutencao,
}) {
  const media = calcMediaConsumo(precoCusto);
  return Number((media + maoDeObra + pneu + manutencao).toFixed(4));
}

export function calcFretePorLitro({
  kilometragem,
  tipoVeiculo = "toco",
  custoVariavel,
  custoFixo = SIMULACAO_DEFAULTS.custoFixo,
}) {
  const km = Number(kilometragem) || 0;
  const cv = Number(custoVariavel) || 0;
  const cf = Number(custoFixo) || 0;
  const divisor =
    tipoVeiculo === "truck"
      ? SIMULACAO_DEFAULTS.divisorTruckCidade
      : SIMULACAO_DEFAULTS.divisorTocoRural;
  return (km * cv) / divisor + cf;
}

/**
 * Preço final de venda (mesma lógica da planilha):
 * precoCusto + frete(km, tipo) + margem
 */
export function calcPrecoFinalSimulacao({
  precoCusto,
  kilometragem,
  tipoVeiculo = "toco",
  margem = SIMULACAO_DEFAULTS.margem,
  maoDeObra = SIMULACAO_DEFAULTS.maoDeObra,
  pneu = SIMULACAO_DEFAULTS.pneu,
  manutencao = SIMULACAO_DEFAULTS.manutencao,
  custoFixo = SIMULACAO_DEFAULTS.custoFixo,
}) {
  const custo = Number(precoCusto) || 0;
  const custoVariavel = calcCustoVariavel({
    precoCusto: custo,
    maoDeObra,
    pneu,
    manutencao,
  });
  const frete = calcFretePorLitro({
    kilometragem,
    tipoVeiculo,
    custoVariavel,
    custoFixo,
  });
  const mg = Number(margem) || 0;
  const precoFinal = custo + frete + mg;

  return {
    precoCusto: custo,
    mediaConsumo: calcMediaConsumo(custo),
    custoVariavel,
    custoFixo: Number(custoFixo) || 0,
    fretePorLitro: Number(frete.toFixed(4)),
    margem: mg,
    precoFinal: Number(precoFinal.toFixed(4)),
    kilometragem: Number(kilometragem) || 0,
    tipoVeiculo,
  };
}
